import { HelmetProvider } from '@vuer-ai/react-helmet-async'
import { Routes, Route, BrowserRouter } from 'react-router-dom'

import { Header } from '@/components/Header'
import { config } from '@/config'
import { ContactsPage } from '@/pages/Contacts'
import { Home } from '@/pages/Home'
import { NotFoundPage } from '@/pages/NotFound'
import { PrivacyPolicyPage } from '@/pages/PrivacyPolicy'
import { TermsConditionsPage } from '@/pages/TermsConditions'

export const AppRoutes = () => {
    return (
        <div className='min-h-screen'>
            <Header/>
            <Routes>
                <Route path='/' element={<Home/>}/>
                <Route path='/contacts' element={<ContactsPage/>}/>
                <Route path='/privacy-policy' element={<PrivacyPolicyPage/>}/>
                <Route path='/terms-conditions' element={<TermsConditionsPage/>}/>
                <Route path='*' element={<NotFoundPage/>}/>
            </Routes>
        </div>
    )
}

export const App = () => {
    return (
        <HelmetProvider>
            <BrowserRouter basename={config.baseUrl}>
                <AppRoutes/>
            </BrowserRouter>
        </HelmetProvider>
    )
}
